// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__7jPap","subtitle":"Hero_subtitle__G-ZGN","description":"Hero_description__447UP","ctaButton":"Hero_ctaButton__rkjg1"};